import { render, staticRenderFns } from "./BaseFilters.vue?vue&type=template&id=09c3122b"
import script from "./BaseFilters.vue?vue&type=script&lang=js"
export * from "./BaseFilters.vue?vue&type=script&lang=js"
import style0 from "./BaseFilters.vue?vue&type=style&index=0&id=09c3122b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports